// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__2h6Tg","optionSelect":"style_optionSelect__1HJdA","option":"style_option__axL0M","selected":"style_selected__3iJOJ"};